import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app"
};
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
export default {
  __name: 'App',

  setup(__props) {
    const locale = zhCn;
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      const _component_el_config_provider = _resolveComponent("el-config-provider");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_config_provider, {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"])]);
    };
  }

};